import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "@components/BrandLogo";
import ActivityPoints from "@components/ActivityPoints";
import ActivityType from "../ActivityType";
import { isContestActivation, parseCMSBold } from "@app/Helpers.js";
import ArrowTip from "./img/arrow-tip-button.svg?react";
import "./style.scss";
import DOMPurify from "dompurify";

export default function ActivityCard({
  mobileImg,
  desktopImg,
  imgDesc,
  copy,
  points,
  brands,
  completed = false,
  ident,
  type,
  highlighted,
  href,
  className = "",
}) {
  const contest = isContestActivation({ ident, type });

  const determineLink = () => {
    if (contest) return `/contest/${ident}`;
    return `/activities/${ident}`;
  };

  return (
    <div
      className={`activity-card-component ${
        completed && !contest ? "completed" : ""
      } ${className ? className : ""} ${highlighted ? "highlighted" : ""}`}
    >
      <Link to={completed && !contest ? "/coupons" : determineLink()}>
        <div className="inner">
          <div className="img-wrapper">
            {completed && !contest && (
              <div className="award-link">
                <span>Punkte eintauschen</span> <ArrowTip />
              </div>
            )}
            <picture>
              <source media="(min-width: 1020px)" srcSet={desktopImg} />
              <img src={mobileImg} alt={imgDesc} />
            </picture>
          </div>
          <BrandLogo brands={brands} />
          <div className="copy">
            {ident === "quiz_18"
              ? null
              : ident === "quiz_20"
              ? null
              : !!points && <ActivityPoints>{points}</ActivityPoints>}

            <ActivityType type={completed ? "completed" : type} />
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(parseCMSBold(copy))}} />
          </div>
        </div>
      </Link>
    </div>
  );
}
